import React from 'react';

const Footer = () => (
    <footer>
        <div className="container py-4">

            <div className="row py-3">
                <div className="col-12 col-sm-6 col-md-3 footer-block">
                    <h6>Services</h6>
                    <a href="/"> Website Development</a>
                    <br />
                    <a href="/"> Mobile App Development</a>
                    <br />
                    <a href="/"> Desktop App Development</a>
                </div>

                <div className="col-12 col-sm-6 col-md-3 footer-block">
                    <h6>Questions?</h6>
                    <a href="/static-privacy-cookies/"> Privacy &amp; Cookies</a>
                    <br />
                    <a href="/static-terms-conditions/"> Terms &amp; Conditions</a>
                </div>

                <div className="col-12 col-sm-6 col-md-3 footer-block">
                    <h6>About Us</h6>
                    <a href="/about/"> About Us</a>
                    <br />
                    <a href="/contact/"> Contact</a>
                </div>

                <div className="col-12 col-sm-6 col-md-3 footer-block">
                    <h6>Social</h6>
                    <a href="https://twitter.com/KentWebApps" target="_blank"> Twitter</a>
                </div>
            </div>
        </div>


        <div className="sub-footer text-center py-4">
            <span>&copy; KentWeb LTD 2018</span>
            <br />
            <span>All rights reserved</span>
            <br />
            <span>Company number: 11416778</span>
        </div>
    </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js